import { useContext, useEffect } from "react";
import { useImmer } from "use-immer";
import { useParams } from "react-router-dom";
import { errorMessage, successMessage } from "../../../utils";
import {
  getStampCardRewardApi,
  getStampCardRewardDetailsApi,
  deleteStampRewardApi,
} from "../api";
import { AppContext } from "../../../store";

export const useStampCardRewardList = () => {
  const { id } = useParams();
  const { appState } = useContext(AppContext);
  const { globalData } = appState;

  const [state, setState] = useImmer({
    isLoading: true,
    dataList: [],
    productsList: [],
    selectedReward: null,
    isproductsLoading: false,
    isModalOpen: false,
    deleteId: null,
    isDeleteModalOpen: false,
  });

  useEffect(() => {
    if (id) {
      getStampCardRewards(id);
    }
  }, [id]);

  const getStampCardRewards = async (stampCardId) => {
    try {
      setState((draft) => {
        draft.isLoading = true;
      });

      const res = await getStampCardRewardApi(stampCardId);

      if (res?.success) {
        setState((draft) => {
          draft.dataList = res.data || [];
          draft.isLoading = false;
        });
      }
    } catch (err) {
      errorMessage(err?.response?.data?.message || "Failed to load rewards");
      setState((draft) => {
        draft.isLoading = false;
      });
    }
  };

  const fetchStampRewardDetails = async (id, rewardId) => {
    try {
      setState((draft) => {
        draft.isproductsLoading = true;
      });
      const res = await getStampCardRewardDetailsApi(id, rewardId);
      if (res.success) {
        setState((draft) => {
          draft.selectedReward = res.data;
        });
      }
    } catch (err) {
      errorMessage("Failed to load reward details");
    } finally {
      setState((draft) => {
        draft.isproductsLoading = false;
      });
    }
  };

  const handleModal = (type, open, rewardId = null) => {
    if (type === "products") {
      setState((draft) => {
        draft.isModalOpen = open;
      });
      if (open && rewardId) {
        fetchStampRewardDetails(id, rewardId);
      }
    } else if (type === "delete") {
      setState((draft) => {
        draft.isDeleteModalOpen = open;
        draft.deleteId = rewardId;
      });
    }
  };

  const confirmDelete = async () => {
    try {
      const res = await deleteStampRewardApi(id, state.deleteId);
      if (res?.success) {
        successMessage(res.message || "Reward deleted successfully");
        // Refresh the rewards list
        setState((draft) => {
          draft.deleteId = null;
          draft.isDeleteModalOpen = false;
        });
        getStampCardRewards(id);
      } else {
        errorMessage(res.message || "Failed to delete reward");
      }
    } catch (err) {
      errorMessage(err?.response?.data?.message || "Failed to delete reward");
    }
  };

  return {
    state,
    globalData,
    handleModal,
    confirmDelete,
  };
};
